import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Pin20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 4.58334C8.38921 4.58334 7.08337 5.88918 7.08337 7.50001C7.08337 9.11084 8.38921 10.4167 10 10.4167C11.6109 10.4167 12.9167 9.11084 12.9167 7.50001C12.9167 5.88918 11.6109 4.58334 10 4.58334ZM8.58337 7.50001C8.58337 6.71761 9.21764 6.08334 10 6.08334C10.7824 6.08334 11.4167 6.71761 11.4167 7.50001C11.4167 8.28241 10.7824 8.91668 10 8.91668C9.21764 8.91668 8.58337 8.28241 8.58337 7.50001Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 19.6022C10.5399 19.0199 11.0741 18.4346 11.5877 17.8288C13.8963 15.1057 17.25 11.2842 17.25 7.5C17.25 3.49594 14.0041 0.25 10 0.25C5.99594 0.25 2.75 3.49594 2.75 7.5C2.75 11.2842 6.10365 15.1057 8.41231 17.8288C8.92593 18.4346 9.4601 19.0199 10 19.6022ZM4.25 7.5C4.25 4.32436 6.82436 1.75 10 1.75C13.1756 1.75 15.75 4.32436 15.75 7.5C15.75 11.0506 12.1711 14.8881 10 17.3744C7.82891 14.8881 4.25 11.0506 4.25 7.5Z'
      fill='currentColor'
    />
  </Svg>
);

Pin20.displayName = 'Pin20';
export default Pin20;
